/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { List, Divider } from "@mui/material";
import { IconButton } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import Config from "data/config";
import { SimplicityDrawer } from "layout/MainLayout/side-nav/drawer";
import { DrawerHeader } from "layout/MainLayout/side-nav/drawer-header";
import { DrawerListItem } from "layout/MainLayout/side-nav/drawer-list-item";
import { isArrayNotEmpty } from "utils/empty-exists";
import { useAllowedMenu } from "cms/auth/hooks/use-allowed-menu";

const SideNav = () => {

    const DEFAULT_PATH = "/dashboard";
    const WEBSITE_PATH = "/website";
    const WEBSITES_PATH = "/websites";

    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const [cookies, setCookie] = useCookies(Config.drawerCookie);

    const { menu } = useAllowedMenu();

    // TODO: Save and restore 'open' state to browser localstorage
    const [openDrawer, setOpenDrawer] = useState(true);
    const [activePath, setActivePath] = useState(pathname);

    useEffect(() => {
        if (pathname === "/") {
            setActivePath(DEFAULT_PATH);
        } else if (pathname.includes(WEBSITE_PATH)) {
            setActivePath(WEBSITES_PATH);
        } else {
            setActivePath(pathname);
        }
    }, [pathname]);

    useEffect(() => {
        const cookie = cookies[Config.drawerCookie];
        if (cookie !== undefined) {
            setOpenDrawer(cookie.toLowerCase() === "true");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleDrawer = () => {
        const nextOpen = !openDrawer;
        setCookie(Config.drawerCookie, nextOpen, {
            path: "/",
            domain: Config.COOKIE_DOMAIN,
        });
        setOpenDrawer(nextOpen);
    };

    const handleListItemClick = (event, path) => {
        setActivePath(path);
        navigate(path);
    };

    return (
        <SimplicityDrawer open={openDrawer}>
            <div className='simplicity-side-nav-content'>
                <div className='simplicity-side-nav-content-logo'>
                    {openDrawer
                        ? <SVGIcons.common.SimpliCityLogo />
                        : <SVGIcons.common.SimpliCityLogoSmall />
                    }
                </div>
                <div className='simplicity-side-nav-content-list'>
                    <List component='nav'>
                        {isArrayNotEmpty(menu) && menu.map((item, idx) => (
                            <DrawerListItem
                                key={idx}
                                item={item}
                                open={openDrawer}
                                activePath={activePath}
                                handleListItemClick={handleListItemClick}
                            />
                        ))}
                    </List>
                </div>
                {openDrawer && (
                    <div className='simplicity-copyright'>
                        <div>
                            &copy; SimpliCity Digital Inc.
                        </div>
                    </div>
                )}
                <Divider />
                <DrawerHeader>
                    <IconButton
                        className='toggle-drawer-btn'
                        onClick={toggleDrawer}
                        style={{ marginRight: "7px" }}
                    >
                        {openDrawer
                            ? <SVGIcons.common.CloseDrawer />
                            : <SVGIcons.common.OpenDrawer />
                        }
                    </IconButton>
                </DrawerHeader>
            </div>
        </SimplicityDrawer>
    );
};

SideNav.displayName = "SideNav";
export { SideNav };
